import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cx = (...args: ClassValue[]) => twMerge(clsx(...args));
